Promise.all([import('../../plugins/semantic/form'), import('../../plugins/semantic/form.scss')]).then(() => {
  Promise.all([
    import('./subscribe.scss'),
    import('../../plugins/semantic/label.css'),
    import('../../plugins/semantic/transition.css'),
    import('../../plugins/semantic/transition'),
    import('../../scripts/dbs/dbs.semantic.form'),
  ]).then(() => {
    $('.widget.subscribe').each(function (i, el) {
      $(el).data('widget', new Subscribe(el))
      $(el).data('widget').init()
    })
  })
})

function Subscribe(el) {
  const self = this
  self.el = $(el)

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('Subscribe init', self)
    }
    self.el.css('opacity', 1)
    if (!self.el.hasClass('no-api')) {
      self.subscribeForm = new dbs.form.genericForm()
      self.subscribeForm.init(self.el.find('.ui.form'))

      self.subscribeForm.submitButton.on('click', function () {
        self.el.find('.ui.message').slideUp().remove()
      })

      self.subscribeForm.events.subscribe('Form:send_success', function (response) {
        //Add this code to make sure that the other form are not affected
        //with the changes.
        let message = response.response.message

        if (message === null || message === undefined || message == '') {
          message = response.response.Message
        }

        self.el.append('<div class="ui small message">' + message + '</div>')
      })
    }
  }
}
